import React, { FunctionComponent, ComponentProps, useContext } from 'react';
import { createPortal } from 'react-dom';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { FixedButtonContainerProviderContext } from '../FixedButtonContainerProvider/FixedButtonContainerProvider';
import styles from './FixedButton.module.css';

export enum FixedButtonType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type FixedButtonProps = Omit<ComponentProps<'button'>, 'type'> & {
  type?: FixedButtonType;
};

export const FixedButton: FunctionComponent<FixedButtonProps> = React.memo(
  (props) => {
    const {
      type = FixedButtonType.Primary,
      children,
      className,
      ...remainingProps
    } = prepareProps({ props });

    const context = useContext(FixedButtonContainerProviderContext);

    if (!context.containerElement) {
      throw new Error(
        'No containerElement in the FixedButtonContainerProviderContext found. Did you forget to wrap your components with a FixedButtonContainerProviderContext?'
      );
    }

    return createPortal(
      <button
        type="button"
        {...remainingProps}
        className={classes(
          className,
          styles.button,
          buttonTypeToClassName[type]
        )}
      >
        {children}
      </button>,
      context.containerElement
    );
  }
);

const buttonTypeToClassName: Record<FixedButtonType, string | null> = {
  primary: styles.buttonPrimary,
  secondary: styles.buttonSecondary
};
